const JSONBig = require("json-bigint");
import excelApi from "@/api/excel/excel";
import { _local, updateExcelExportQueen, exportQueenKey } from "./storage";
import { Notification } from "element-ui";
import store from "@/store";

// 下载信息
export function attachmentDownload(data) {
  // websocket 有信息 & 下载
  if (data && data.webSocketType === "excel-export") {
    const { excelRecord } = data;
    const { attachmentId, id } = excelRecord;

    if (!attachmentId) {
      return;
    }

    const attachmentIdStr = attachmentId.toString();
    const idStr = id.toString();

    const queen = _local.get(exportQueenKey);
    if (Array.isArray(queen) && queen.includes(idStr)) {
      updateExcelExportQueen({ id: idStr, type: "remove" });
      excelApi.downloadAttachment(attachmentIdStr).then(result => {
        if (!result || !result.data) {
          return;
        }
        const blob = new Blob([result.data], { type: "application/vnd.ms-excel" }); // 构造一个blob对象来处理数据
        const fileName = result.filename; // 导出文件名对于<a>标签，只有Firefox和Chrome（内核）支持download属性 IE10以上支持blob但是依然不支持download
        if ("download" in document.createElement("a")) {
          // 支持a标签download的浏览器
          const link = document.createElement("a"); // 创建a标签
          link.download = fileName; // a标签添加属性
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); // 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link); // 释放标签
        } else {
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      });
    }
  }
}

// 导入信息
export function attachmentImport(data) {
  // websocket 有信息 & 下载
  if (data && data.webSocketType === "excel-import") {
    const { excelRecord } = data;
    const { id, success } = excelRecord;

    const idStr = id.toString();

    const queen = _local.get("importQueen");
    if (Array.isArray(queen) && queen.includes(idStr)) {
      updateExcelExportQueen({ id: idStr, type: "remove" }, "importQueen");
      if (success) {
        Notification.success({
          title: "成功",
          message: "文件导入成功！"
        });
      }
    }
  }
}

// 导入导出信息提醒
export function attachmentNotify() {
  return data => {
    // websocket 有信息 & 下载
    if (data && ["excel-import", "excel-export"].includes(data.webSocketType)) {
      store.dispatch("settings/changeSetting", { key: "openAttachmentNotify", value: true });
    }
  };
}

export default class SocketService {
  static instance = null;
  static get Instance() {
    if (!this.instance) {
      this.instance = new SocketService();
    }

    return this.instance;
  }
  // socket 对象
  ws = null;
  // 存储回调函数
  callBackMapping = {};
  // 标识是否连接成功
  connected = false;
  // 心跳检测频率
  _timeout = 20000;
  // 心跳检测
  isHeart = true;
  // 定时器
  pingInterval = null;
  // 重连次数
  connectRetryCount = 0;
  // 定义连接服务器
  connect() {
    // 连接服务器
    if (!window.WebSocket) {
      return console.log("您的浏览器不支持WebSocket!");
    }

    // 开发环境不开启socket
    if (process.env.NODE_ENV === "development") {
      return;
    }

    try {
      this.ws = new WebSocket(`ws://${location.host}/admin/ws`);

      // 连接成功事件
      this.ws.onopen = () => {
        console.log("websocket connect success!");

        this.connected = true;
        // 重置重新连接的次数
        this.connectRetryCount = 0;
        // 开启心跳检测
        if (this.isHeart) {
          this._heartCheck();
        }
      };

      // 1.连接服务端失败
      // 2.当连接成功之后, 服务器关闭的情况(连接失败重连)
      this.ws.onclose = () => {
        console.log("websocket connect failed!");
        this.connected = false;
        this.connectRetryCount++;

        // 重连
        setTimeout(() => {
          this.connect();
        }, 500 * this.connectRetryCount);
        this._closeSocket();
      };

      // 得到服务端发送过来的数据
      this.ws.onmessage = msg => {
        // console.log(`从服务端获取到了数据${msg.data}`, this.callBackMapping);
        // 使用json-bigint处理Number精度丢失的问题
        // eslint-disable-next-line no-useless-call
        for (const key in this.callBackMapping) {
          this.callBackMapping[key].call(this, JSONBig.parse(msg.data));
        }
      };
    } catch (error) {
      console.info("error", error);
    }
  }
  // 心跳监测
  _heartCheck() {
    this.pingInterval = setInterval(() => {
      if (this.ws.readyState === 1) {
        this.ws.send(JSON.stringify({ webSocketType: "ping" }));
      }
    }, this._timeout);
  }
  // 重置心跳检测
  _resetHeart() {
    clearInterval(this.pingInterval);
    return this;
  }
  // 关闭socket
  _closeSocket() {
    this._resetHeart();
  }
  // 回调函数的注册
  registerCallBack({ key, callBack }) {
    if (!this.callBackMapping[key]) {
      this.callBackMapping[key] = callBack;
    }
  }
  // 取消某一个回调函数
  unRegisterCallBack(key) {
    delete this.callBackMapping[key];
  }
  // 发送数据的方法
  send(data) {
    // 判断此时此刻有没有连接成功
    if (this.connected) {
      this.sendRetryCount = 0;
      this.ws.send(data);
    }
  }
}
